import axios from 'axios'
import { Message as ElementMessage } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'

const ERROR_MESSAGE_DURATION = 5 * 1000
const shownErrorMessages = new Map()

function Message(options) {
  const normalizedMessage = String((options && options.message) || '请求失败').trim()

  if (shownErrorMessages.has(normalizedMessage)) {
    return
  }

  shownErrorMessages.set(normalizedMessage, true)
  ElementMessage({
    ...options,
    message: normalizedMessage,
    duration: (options && options.duration) || ERROR_MESSAGE_DURATION
  })

  setTimeout(() => {
    shownErrorMessages.delete(normalizedMessage)
  }, (options && options.duration) || ERROR_MESSAGE_DURATION)
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (localStorage.getItem("token")) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem("token") // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    const responseCode = Number(res && res.code)
    const hasBusinessError = res && (
      responseCode >= 400 ||
      res.success === false
    )

    if (hasBusinessError) {
      const message = res.msg || res.message || '接口请求失败'
      const businessError = new Error(message)
      businessError.code = res.code
      businessError.response = response
      Message({
        message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(businessError)
    }

    return res

  },
  error => {
    Message({
      message: '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
